<template>
    <v-card>
        <v-card-title>
            {{$t('event_flight.items')}}
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initAddFlightItem">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="tableFlights"
                      :loading="isFlightItemPending"
                      @pagination="currentPagination"
                      disable-sort>
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.date="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('date')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('flight_item.date')"
                                :placeholder="$t('flight_item.date')"
                                v-model="inlineEditingFlightItemList[item.id].date"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('date'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('date'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.flight_number="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('flight_number')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('flight_item.flight_number')"
                                :placeholder="$t('flight_item.flight_number')"
                                v-model="inlineEditingFlightItemList[item.id].flight_number"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('flight_number'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('flight_number'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.itinerary="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('itinerary')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('flight_item.itinerary')"
                                :placeholder="$t('flight_item.itinerary')"
                                v-model="inlineEditingFlightItemList[item.id].itinerary"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('itinerary'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('itinerary'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.departure_time="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('departure_time')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('flight_item.departure_time')"
                                :placeholder="$t('flight_item.departure_time')"
                                v-model="inlineEditingFlightItemList[item.id].departure_time"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('departure_time'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('departure_time'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.arrival_time="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('arrival_time')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('flight_item.arrival_time')"
                                :placeholder="$t('flight_item.arrival_time')"
                                v-model="inlineEditingFlightItemList[item.id].arrival_time"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('arrival_time'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('arrival_time'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.updatedAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                       @click="initEditFlightItem(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                       @click="deleteFlightItem(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editFlightItemDialogShown"
                  max-width="600px"
                  persistent
                  scrollable
                  :retain-focus="false"
                  >
            <v-card>
                <v-card-title>
                    {{$t('flight_item.title')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditFlightItemFormValid">
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.order')"
                                                  :rules=[flightOrderRule]
                                                  :placeholder="$t('flight_item.order')"
                                                  v-model="editingFlightItem.order"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.date')"
                                                  :placeholder="$t('flight_item.date')"
                                                  v-model="editingFlightItem.date"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.flight_number')"
                                                  :placeholder="$t('flight_item.flight_number')"
                                                  v-model="editingFlightItem.flight_number"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.itinerary')"
                                                  :placeholder="$t('flight_item.itinerary')"
                                                  v-model="editingFlightItem.itinerary"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.departure_time')"
                                                  :placeholder="$t('flight_item.departure_time')"
                                                  v-model="editingFlightItem.departure_time"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.arrival_time')"
                                                  :placeholder="$t('flight_item.arrival_time')"
                                                  v-model="editingFlightItem.arrival_time"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('flight_item.flight_key')"
                                                  :placeholder="$t('flight_item.flight_key')"
                                                  v-model="editingFlightItem.flight_key"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('flight_item.description')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingFlightItem.description"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('flight_item.content')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingFlightItem.content"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveFlightItem"
                           :disabled="!isEditFlightItemFormValid">{{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditFlightItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
            ></PopupAlert>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width: 10px;
    }
</style>

<script>
    import {computed, ref, onMounted, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep} from "lodash";
    import Sortable from "sortablejs";
    import PopupAlert from "../../components/PopupAlert";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventFlightItemList',
        props: {
            flightId: String,
        },
        components:{PopupAlert},
        setup(props, {root}) {
            const {FlightItem} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const flightItemParams = computed(() => {
                return {
                    query: {
                        fFlightId: props.flightId,
                        $sort: {order: 1},
                    }
                }
            })
            const flightItemQueryWhen = computed(() => {
                return !!props.flightId;
            });
            const {items: flightItems, isPending: isFlightItemPending} = useFind({
                model: FlightItem,
                params: flightItemParams,
                queryWhen: flightItemQueryWhen,
            });

            // Data Table
            const headers = ref([
                {text:'',value:'scroller',width:80},
                {text: root.$t('flight_item.order'), value: 'order'},
                {text: root.$t('flight_item.date'), value: 'date'},
                {text: root.$t('flight_item.flight_number'), value: 'flight_number'},
                {text: root.$t('flight_item.itinerary'), value: 'itinerary'},
                {text: root.$t('flight_item.departure_time'), value: 'departure_time'},
                {text: root.$t('flight_item.arrival_time'), value: 'arrival_time'},
                {text: '', value: 'actions'},
            ]);

            const currentStart = ref(0);

            const currentPagination = function(e){
                currentStart.value = e.pageStart
            }
            // Add / Edit Flight Item
            const editFlightItemDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const isEditFlightItemFormValid = ref(false);

            const editOrderFlight = ref([])
            const didOrderChange = ref(false);
            const isEditOrderMode = ref(false);
            const overlay = ref(false);
            const inlineSaving = ref(false);

            const editingFlightItem = ref(new FlightItem({fFlightId: props.flightId}));
            const inlineEditingFlightItemList = ref({})
            const initAddFlightItem = function () {
                editingFlightItem.value = new FlightItem({fFlightId: props.flightId});
                editingFlightItem.value.order = flightItems.value.length + 1
                editFlightItemDialogShown.value = true;
            };
            const initEditFlightItem = function (flightItem) {
                if(!isEditOrderMode.value){
                    editingFlightItem.value = cloneDeep(flightItem);
                    editFlightItemDialogShown.value = true;
                }
            };
            const deleteFlightItem = function (flightItem) {
                if(!isEditOrderMode.value){                
                    if (confirm(root.$t('flight_item.confirm_delete'))) {
                        flightItem.remove().then(() => {
                        }, root.$handleFeatherError.bind(root));
                    }
                }
            };
            const saveFlightItem = async function () {
                editingFlightItem.value.save().then(() => {
                    FlightItem.get(editingFlightItem.value.id);
                    editFlightItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('flight_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };
            const cancelEditFlightItem = function(){
                editFlightItemDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }
            watch(flightItems,(flightItems,old)=>{
                const newList = {}
                for(let i=0;i<flightItems.length;i++){
                    newList[flightItems[i].id] = cloneDeep(flightItems[i])
                }
                inlineEditingFlightItemList.value = newList
            })

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };
            const openInline = function(flightItem){
                inlineEditingFlightItemList.value[flightItem.id] = cloneDeep(flightItem)
            }
            const cancelInline = function(item, ref=null){
                if (ref) {
                    this.$refs[ref].isActive = false;
                }
            }
            const saveInlineItem = async function (item, ref=null){
                inlineSaving.value = true;
                await inlineEditingFlightItemList.value[item.id].save().then(()=>{
                    FlightItem.get(item.id).then(()=>{
                    });
                    root.$store.dispatch('showSnackBar', root.$t('flight_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
                inlineSaving.value = false;
                if (ref) {
                    this.$refs[ref].isActive = false;
                }
            }
            
            const initEditOrder = function() {
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderFlight.value = cloneDeep(sortedFlightItems.value);
            }
            const saveEditOrder = async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderFlight.value.length;i++){
                    await editOrderFlight.value[i].save().then(()=>{
                        FlightItem.get(editOrderFlight.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false;
            }

            const quickSortFlightItems = function(sortFlightItems){
                if(sortFlightItems.length<2){
                    return sortFlightItems
                }

                const chosenIndex = sortFlightItems.length - 1
                const chosen  = sortFlightItems[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortFlightItems[i].order
                    temp < chosen.order ? a.push(sortFlightItems[i]) : b.push(sortFlightItems[i])
                }
                const output = [...quickSortFlightItems(a),chosen,...quickSortFlightItems(b)]
                return output
            }

            const tableFlights = computed(()=>{
                return isEditOrderMode.value ? editOrderFlight.value : sortedFlightItems.value;
            })

            const sortedFlightItems = computed(()=>{
                return quickSortFlightItems(flightItems.value)
            })

            onMounted(() => {
                let tables = document.querySelectorAll('.v-data-table tbody');
                Sortable.create(tables[1],
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderFlight.value.splice(oldIndex,1)[0];
                            editOrderFlight.value.splice(newIndex,0,rowSelected);

                            didOrderChange.value = true
                            for(let i=0;i<editOrderFlight.value.length;i++){
                                editOrderFlight.value[i].order = i+1
                            }
                            editOrderFlight.value = quickSortFlightItems(editOrderFlight.value);
                        }
                    }
                )
            });

            const flightOrderRule = function(value){
                const onlyNumberRule =  /^[0-9]+$/;
                return onlyNumberRule.test(value) || 'Invalid Number';
            }

            const truncate = (str) => {
                if (str.length > 35) {
                    return str.substr(0, 20) + '...' + str.substr(str.length - 10, str.length);
                } else {
                    return str;
                }
            }

            const open = (link, target) => {
                window.open(link, target);
            }

            return {
                flightItems,
                tableFlights,
                isFlightItemPending,
                inlineEditingFlightItemList,
                headers,

                editFlightItemDialogShown,
                confirmCancelItemDialogShown,
                initAddFlightItem,
                initEditFlightItem,
                deleteFlightItem,
                isEditFlightItemFormValid,
                editingFlightItem,
                saveFlightItem,
                cancelEditFlightItem,
                
                DateTime,

                previewHtmlContentOption,
                openInline,
                cancelInline,
                saveInlineItem,

                overlay,
                inlineSaving,
                isEditOrderMode,
                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                currentPagination,
                flightOrderRule,

                getFileUrl: root.$getFileURL,
                open,
                truncate,

                showEditor,
                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
